module.exports = __webpack_public_path__ + "assets/email.55faa821.svg";